import { useEffect, useState } from "react";
import { BACKEND, bgStyle } from "@/lib/api";

const SLOTS = ["large", "medium", "small"];
const SHEEN = "linear-gradient(118deg, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0.03) 30%, rgba(255,255,255,0.12) 42%, rgba(255,255,255,0.02) 58%, rgba(255,255,255,0) 100%)";

export const ScenePreview = ({ scene, photos }) => {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);
  const n = scene.collections.length;

  useEffect(() => {
    if (paused) return;
    const t = setInterval(() => setActive((a) => (a + 1) % n), scene.segment * 1000);
    return () => clearInterval(t);
  }, [paused, n, scene.segment]);

  const pct = (v, total) => `${(v / total) * 100}%`;

  return (
    <div className="space-y-4">
      <div data-testid="scene-preview" className="relative aspect-video overflow-hidden bg-[#EDE7DD] shadow-[0_30px_60px_-30px_rgba(28,23,21,0.35)]">
        <img src={`${BACKEND}/api/scene/base.jpg`} alt="Salón LUMINA" className="absolute inset-0 h-full w-full" />
        {scene.collections.map((c, ci) => (
          <div key={c.id} className="absolute inset-0 transition-opacity ease-in-out" style={{ opacity: ci === active ? 1 : 0, transitionDuration: `${scene.fade}s` }}>
            {SLOTS.map((s) => {
              const p = photos.find((x) => x.collection === c.id && x.slot === s);
              if (!p) return null;
              const r = scene.panels[s];
              return (
                <div key={s} className="absolute overflow-hidden" style={{
                  left: pct(r.x, scene.width), top: pct(r.y, scene.height), width: pct(r.w, scene.width), height: pct(r.h, scene.height),
                  borderRadius: `${(r.w / scene.width) * 100 * 0.04}%`,
                }}>
                  <div className="absolute inset-0" style={bgStyle(p, r.w / r.h)} />
                  <div className="absolute inset-0" style={{ background: SHEEN, boxShadow: "inset 1px 1px 0 rgba(255,255,255,0.35)" }} />
                </div>
              );
            })}
          </div>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {scene.collections.map((c, ci) => (
          <button key={c.id} data-testid={`preview-collection-${c.id}`} onClick={() => { setActive(ci); setPaused(true); }}
            className={`rounded-full border px-4 py-1.5 text-xs transition-colors ${ci === active ? "border-[#1C1715] bg-[#1C1715] text-[#FDFBF7]" : "border-[#1C1715]/15 text-[#5C534C] hover:border-[#1C1715]/40"}`}>
            {ci + 1}. {c.title}
          </button>
        ))}
        <button data-testid="preview-play-toggle" onClick={() => setPaused((p) => !p)} className="ml-auto text-xs uppercase tracking-[0.2em] text-[#A67C52] hover:text-[#1C1715] transition-colors">
          {paused ? "Reanudar bucle" : "Pausar"}
        </button>
      </div>
    </div>
  );
};
